//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../GeometricUtilities/GeometricUtilities.LawBuilder.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
let d=[[[0,"AngleTolerance",1,0],[0,"CoordinateSystem",1,"CoordinateSystem",0],[0,"DistanceTolerance",1,0],[1,"EndLimit",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"LengthMethod",1,0],[0,"NumberOfTurns",1,1],[0,"OrientationOption",1,0],[1,"PitchLaw",0,"GeometricUtilities.LawBuilder",0],[1,"SizeLaw",0,"GeometricUtilities.LawBuilder",0],[0,"SizeOption",1,0],[1,"Spine",0,"Section",0],[1,"StartAngle",0,"Expression",0],[1,"StartLimit",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"TurnDirection",1,0],[1,"Turns",0,"Expression",0],[0,"Type",1,0]],[[[],"Evaluate",{},0,0]],[]];
SPLM.Features.HelixBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.HelixBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.HelixBuilder.Types = Object.freeze({
    "AlongVector" : "AlongVector", "AlongSpine" : "AlongSpine"});

SPLM.Features.HelixBuilder.OrientationOptions = Object.freeze({
    "Inferred" : "Inferred", "Specified" : "Specified"});

SPLM.Features.HelixBuilder.SizeOptions = Object.freeze({
    "Diameter" : "Diameter", "Radius" : "Radius"});

SPLM.Features.HelixBuilder.LengthMethods = Object.freeze({
    "Limits" : "Limits", "Turns" : "Turns"});

SPLM.Features.HelixBuilder.TurnDirections = Object.freeze({
    "RightHand" : "RightHand", "LeftHand" : "LeftHand"});

export default SPLM;